import { NavLink } from "react-router-dom";
import {
  HiOutlineCalendar,
  HiOutlineUsers,
  HiOutlineChartBar,
  HiOutlineTruck,
  HiOutlineDocumentText
} from "react-icons/hi";
import { FaCrown } from "react-icons/fa";
import LogoutButton from "./LogoutButton";

function Navigation() {
  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 rounded-lg px-4 py-2 ${isActive
      ? "text-gray-600"
      : "text-gray-700 hover:bg-gray-100"
    }`;

  return (
    <aside className="w-64 bg-white border-r">
      <div className="p-6 border-b">
        <h1 className="text-xl font-bold">Torque Desk</h1>
        <p className="text-sm text-gray-500">Admin Panel</p>
      </div>

      <nav className="p-4 space-y-2">


        <NavLink to="appointment" className={linkClass}>
          <HiOutlineCalendar className="text-lg" />
          Appointments
        </NavLink>

        <NavLink to="/vehicles" className={linkClass}>
          <HiOutlineTruck className="text-lg" />
          Vehicle Record
        </NavLink>
        <NavLink to="/services" className={linkClass}>
          <HiOutlineTruck className="text-lg" />
          Manage Services
        </NavLink>

        <NavLink to="/quotes" className={linkClass}>
          <HiOutlineDocumentText className="text-lg" />
          Quote Request
        </NavLink>

        <NavLink to="/" end className={(isActive) => ` ${linkClass(isActive)} opacity-60 cursor-not-allowed pointer-events-none`}>
          <HiOutlineUsers className="text-lg" />
          Client Record <FaCrown className="text-lg" />
        </NavLink>

        <NavLink to="/" end className={(isActive) => ` ${linkClass(isActive)} opacity-60 cursor-not-allowed pointer-events-none`}  >
          <HiOutlineChartBar className="text-lg" />
          Analytics <FaCrown className="text-lg" />
        </NavLink>

      </nav>

      <div className="border-t p-4">
        <LogoutButton />
      </div>
    </aside>
  );
}

export default Navigation;